(function () {
  'use strict';

  var dialog = document.getElementById('mg-customizer');
  if (!dialog) return;

  var dataEl = document.getElementById('mg-customizer-data');
  var data = JSON.parse(dataEl.textContent);
  var form = document.getElementById('mg-customizer-form');
  var colorsContainer = form.querySelector('[data-mg-colors]');
  var variantIdInput = form.querySelector('[data-mg-variant-id]');
  var quantityInput = form.querySelector('[data-mg-quantity]');
  var totalEl = form.querySelector('[data-mg-total]');
  var discountNoteEl = form.querySelector('[data-mg-discount-note]');
  var submitBtn = form.querySelector('[data-mg-submit]');
  var feedbackEl = form.querySelector('[data-mg-feedback]');
  var dropzone = form.querySelector('[data-mg-dropzone]');
  var fileInput = form.querySelector('[data-mg-file-input]');
  var dropzoneText = form.querySelector('[data-mg-dropzone-text]');

  var state = {
    productHandle: null,
    color: null
  };

  function findProduct(handle) {
    for (var i = 0; i < data.products.length; i++) {
      if (data.products[i].handle === handle) return data.products[i];
    }
    return null;
  }

  function findVariant(product, color) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].color === color) return product.variants[i];
    }
    return null;
  }

  function discountFor(qty) {
    for (var i = 0; i < data.volumeTiers.length; i++) {
      if (qty >= data.volumeTiers[i].min) return data.volumeTiers[i];
    }
    return { min: 0, discount: 0 };
  }

  function renderColors() {
    colorsContainer.innerHTML = '';
    data.colors.forEach(function (color) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mg-customizer__color-option';
      btn.style.setProperty('--mg-swatch-color', color.hex);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', color.name);
      btn.dataset.mgColor = color.name;
      colorsContainer.appendChild(btn);
    });
  }

  function updateProductSelectionUI() {
    form.querySelectorAll('[data-mg-product]').forEach(function (btn) {
      var active = btn.dataset.handle === state.productHandle;
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-selected', active);
    });
  }

  function updateColorSelectionUI() {
    colorsContainer.querySelectorAll('[data-mg-color]').forEach(function (btn) {
      var active = btn.dataset.mgColor === state.color;
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-selected', active);
    });
  }

  function updateSummary() {
    var product = findProduct(state.productHandle);
    var variant = findVariant(product, state.color);
    var qty = Math.max(5, parseInt(quantityInput.value, 10) || 5);
    quantityInput.value = qty;

    if (!variant) {
      totalEl.textContent = '—';
      discountNoteEl.hidden = true;
      variantIdInput.value = '';
      submitBtn.disabled = true;
      return;
    }

    var tier = discountFor(qty);
    var basePrice = parseFloat(variant.price);
    var lineTotal = basePrice * qty;
    var discountedTotal = lineTotal * (1 - tier.discount);

    if (tier.discount > 0) {
      discountNoteEl.hidden = false;
      discountNoteEl.textContent = 'Descuento por volumen aplicado: -' + Math.round(tier.discount * 100) + '%';
    } else {
      discountNoteEl.hidden = true;
    }

    totalEl.textContent = formatMoney(discountedTotal);
    variantIdInput.value = variant.id;
    submitBtn.disabled = false;
  }

  function formatMoney(amount) {
    return amount.toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }

  function openCustomizer(productHandle) {
    if (productHandle && findProduct(productHandle)) {
      state.productHandle = productHandle;
    } else if (!state.productHandle && data.products.length) {
      state.productHandle = data.products[0].handle;
    }
    updateProductSelectionUI();
    updateSummary();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeCustomizer() {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  renderColors();

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('.mg-open-customizer');
    if (opener) {
      event.preventDefault();
      openCustomizer(opener.dataset.productHandle);
      return;
    }
    if (event.target.closest('[data-mg-close]')) {
      closeCustomizer();
      return;
    }
    var productOption = event.target.closest('[data-mg-product]');
    if (productOption) {
      state.productHandle = productOption.dataset.handle;
      updateProductSelectionUI();
      updateSummary();
      return;
    }
    var colorOption = event.target.closest('[data-mg-color]');
    if (colorOption) {
      state.color = colorOption.dataset.mgColor;
      updateColorSelectionUI();
      updateSummary();
      return;
    }
    var qtyPreset = event.target.closest('[data-mg-qty-preset]');
    if (qtyPreset) {
      quantityInput.value = qtyPreset.dataset.mgQtyPreset;
      updateSummary();
      return;
    }
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeCustomizer();
  });

  quantityInput.addEventListener('input', updateSummary);

  ['dragover', 'dragenter'].forEach(function (evtName) {
    dropzone.addEventListener(evtName, function (event) {
      event.preventDefault();
      dropzone.classList.add('is-dragover');
    });
  });
  ['dragleave', 'drop'].forEach(function (evtName) {
    dropzone.addEventListener(evtName, function (event) {
      event.preventDefault();
      dropzone.classList.remove('is-dragover');
    });
  });
  dropzone.addEventListener('drop', function (event) {
    var file = event.dataTransfer.files[0];
    if (file) {
      fileInput.files = event.dataTransfer.files;
      dropzoneText.textContent = file.name;
    }
  });
  fileInput.addEventListener('change', function () {
    if (fileInput.files[0]) dropzoneText.textContent = fileInput.files[0].name;
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!variantIdInput.value) return;

    submitBtn.disabled = true;
    feedbackEl.textContent = 'Añadiendo a la cesta…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart_add_failed');
        return response.json();
      })
      .then(function () {
        feedbackEl.innerHTML = 'Añadido a la cesta. <a href="/cart">Ver cesta</a>';
        submitBtn.disabled = false;
      })
      .catch(function () {
        feedbackEl.textContent = 'No se pudo añadir a la cesta. Inténtalo de nuevo.';
        submitBtn.disabled = false;
      });
  });
})();
